import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { Helmet } from 'react-helmet'

const Login = (props) =>
  <div>
    <Helmet>
      <title>OTC CMS | Login</title>
    </Helmet>
    <h3>Login</h3>
    <hr />

    <Row>
      <Col sm={{ size: 6, push: 2, pull: 2, offset: 1 }}>
        <Form onSubmit={props.onSubmit}>
          <FormGroup>
            <Label for='exampleEmail'>Email</Label>
            <Input type='email' name='email' id='email' placeholder='Enter email address' size='lg' onChange={props.onEmailChange} />
          </FormGroup>

          <FormGroup>
            <Label for='exampleEmail'>Password</Label>
            <Input type='password' name='password' id='password' size='lg' onChange={props.onPasswordChange} />
          </FormGroup>

          <Button color='primary' size='lg' block>Login</Button>
        </Form>
      </Col>
    </Row>
  </div>

Login.propTypes = {
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default Login



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js